"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _fonts = require("../fonts");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Label = (0, _styledComponents.default)(_reactstrap.Label).attrs(function (_ref) {
  var children = _ref.children;
  return {
    children: /*#__PURE__*/_react.default.createElement(_fonts.MediumSpan, null, children)
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: default;\n  color: ", ";\n  display: ", ";\n  margin-bottom: ", ";\n  line-height: initial;\n"])), function (_ref2) {
  var theme = _ref2.theme,
    disabled = _ref2.disabled;
  return disabled ? theme.colors.secondaryShade2 : theme.colors.tertiary;
}, function (_ref3) {
  var check = _ref3.check;
  return check ? 'flex' : 'block';
}, function (_ref4) {
  var check = _ref4.check;
  return check ? 0 : '10px';
});
exports.Label = Label;